import React from 'react';
import { Link } from 'react-router-dom';
import RoutePath from '../../../constants/route-paths';
import Theming from '../../../constants/theming';
import { getSmallUrl } from '../../../helpers/image_helpers';
import MediaHelpers from '../../../helpers/media_file_helpers';
import { genRoutePath } from '../../../helpers/route_helpers';
import { EventModel } from '../../../models/event';
import PlaceholderImg from '../../templates/PlaceholderImg';

const routeToEvent = (eventId: string) => genRoutePath([RoutePath.events, eventId]);

interface EventCardProps {
    event: EventModel;
}

export default class EventCard extends React.Component<EventCardProps> {
    render() {
        return (
            <div className="col-lg-4 col-md-6 mb-4">

                <div className="card">

                    <div className="view overlay">
                        <PlaceholderImg
                            style={{ height: "30vh", objectFit: "cover" }}
                            className="card-img-top"
                            blurhash={this.props.event.thumbnail.formats.blurhash}
                            src={MediaHelpers.resolveMediaUrl(getSmallUrl(this.props.event.thumbnail))}
                            alt="" />
                        <Link to={routeToEvent(this.props.event.id)}>
                            <div className="mask rgba-white-slight"></div>
                        </Link>
                    </div>

                    <div className="card-body text-left">
                        <p>
                            <strong>
                                <i className="far fa-clock"></i> {new Date(this.props.event.date).toLocaleDateString("en-IN")}
                            </strong>
                        </p>

                        <h4 className="card-title">{this.props.event.title}</h4>

                        <Link to={routeToEvent(this.props.event.id)} className="btn btn-md" style={{ backgroundColor: Theming.backgroundColourDark, color: Theming.textColourDark }}>
                            More Details
            <i className="fas fa-play ml-2"></i>
                        </Link>
                    </div>

                </div>
            </div>
        );
    }
}